var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldstar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4307_15868)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M40.4277 23.1062C38.4814 16.1775 31.3581 9.75488 31.3581 9.75488C25.4415 16.7225 22.3664 23.0284 22.3664 23.0284C15.5545 25.0525 9.4043 32.1758 9.4043 32.1758C16.2551 38.2481 22.3664 41.1675 22.3664 41.1675C24.3127 48.0962 31.3581 54.5967 31.3581 54.5967C37.3137 47.6291 40.4277 41.2843 40.4277 41.2843C47.2396 39.2991 53.3119 32.1758 53.3119 32.1758C46.5 26.1035 40.4277 23.1062 40.4277 23.1062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3378 24.0015C37.3915 17.0728 31.3581 9.75488 31.3581 9.75488C25.4415 16.7225 23.3395 24.0015 23.3395 24.0015C16.5665 26.0256 9.4043 32.1758 9.4043 32.1758C16.2551 38.2481 23.3785 40.3501 23.3785 40.3501C25.3247 47.2788 31.3581 54.5967 31.3581 54.5967C37.3137 47.6291 39.3378 40.3501 39.3378 40.3501C46.1497 38.3649 53.3119 32.1758 53.3119 32.1758C46.5 26.1035 39.3378 24.0015 39.3378 24.0015Z",
    fill: "#600A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8308 24.5077C37.0014 18.124 31.3572 11.4678 31.3572 11.4678C25.7909 17.8515 23.8836 24.5077 23.8836 24.5077C17.4998 26.3372 10.8047 31.9814 10.8047 31.9814C17.1884 37.5477 23.8836 39.455 23.8836 39.455C25.713 45.7998 31.3572 52.495 31.3572 52.495C36.9235 46.1112 38.8308 39.455 38.8308 39.455C45.1757 37.6255 51.9097 31.9814 51.9097 31.9814C45.526 26.4151 38.8308 24.5077 38.8308 24.5077Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M29.1779 31.2029C27.6988 30.1909 24.8572 26.7655 24.1177 24.8192C24.1177 24.8192 24.1177 24.8192 23.8841 24.5078C18.0453 26.1816 11.973 31.0083 10.9609 31.8647C11.0777 31.9036 11.2334 31.9425 11.3891 31.9815C19.4856 34.317 30.6571 32.215 29.1779 31.2029Z",
    fill: "#FFA94A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M33.3821 31.5533C32.0587 32.4486 44.5926 35.0565 51.9105 31.9815C45.5268 26.4151 38.8317 24.5078 38.8317 24.5078C39.3377 26.2205 34.7445 30.658 33.3821 31.5533Z",
    fill: "#FFA94A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.3984 32.7589C12.0119 32.4864 20.4197 38.1695 23.0666 38.7923C25.7136 39.4151 31.3577 31.3186 28.7497 31.9414C26.1028 32.6032 23.4559 33.4206 15.3984 32.7589Z",
    fill: "#8B002C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M15.0863 32.7211C11.5441 32.254 16.7601 32.9157 21.1975 32.3318C25.635 31.748 29.294 30.9305 29.3329 31.5533C29.3718 32.1761 23.027 33.7721 15.0863 32.7211Z",
    fill: "#FFA94A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M24.9351 22.1334C24.5069 24.6246 29.139 31.3197 29.9954 27.3883C30.8517 23.4568 32.798 9.59946 29.9954 13.3363C27.1928 17.0731 25.2076 20.6542 24.9351 22.1334Z",
    fill: "#FFA94A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M32.6036 24.8201C31.9029 20.0323 31.0077 12.0137 32.915 14.0767C34.8223 16.1397 38.0142 22.6402 38.0921 24.6254C38.1699 26.6106 33.6935 32.2937 32.6036 24.8201Z",
    fill: "#D4D8A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.8484 32.1764C32.9531 31.9817 35.8725 38.1709 38.5584 38.9883C41.2442 39.8057 50.5863 33.3441 47.0441 33.3831C43.5019 33.422 39.259 33.4998 36.8846 32.9159C34.4712 32.3321 33.8484 32.1764 33.8484 32.1764Z",
    fill: "#8B002C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M34.355 32.2921C32.0973 31.786 37.975 32.7981 44.6312 32.2921C48.6016 32.0196 53.3115 31.7082 51.0539 32.2921C48.8351 32.9149 44.3587 34.4719 34.355 32.2921Z",
    fill: "#FFA94A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M31.6301 30.8525C32.4475 32.7209 31.9025 23.3789 32.0193 20.3038C32.0193 20.3038 40.7386 29.9962 38.2863 22.8339C36.0675 17.0341 31.3576 11.4678 31.3576 11.4678C31.3576 17.2676 30.4234 28.1278 31.6301 30.8525Z",
    fill: "#FFA94A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M31.6303 19.3303C31.4746 18.5907 30.7739 25.9476 31.2021 28.6334C31.6303 31.3192 32.0585 32.2534 32.0195 27.777C31.9806 23.3006 32.0974 21.5879 31.6303 19.3303Z",
    fill: "#FFA94A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.5463 39.4548C24.0792 36.6132 30.3462 43.503 31.3582 46.8116C31.3582 46.8116 33.7716 41.5567 36.2628 39.4937C38.754 37.4307 37.7809 44.5929 31.1247 51.0156C31.1247 50.9766 25.4416 44.9043 24.5463 39.4548Z",
    fill: "#8B002C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.9221 39.4547C22.949 36.4186 26.1409 33.4992 28.7489 31.9811C31.3569 30.463 31.4347 32.4871 31.5515 37.1971C31.6683 41.907 31.3958 52.5336 31.3958 52.5336C31.3958 52.5336 26.4134 47.2398 23.9221 39.4547Z",
    fill: "#8B002C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.2376 34.0054C33.4201 30.8524 42.2172 40.1945 38.5583 38.9489C34.8993 37.7422 34.2376 34.0054 34.2376 34.0054Z",
    fill: "#650056"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M31.5518 36.224C31.6296 31.9812 32.2913 36.5743 32.6806 39.1045C33.0698 41.5957 31.5518 47.3177 31.5518 45.7218C31.5518 44.0869 31.5518 36.224 31.5518 36.224Z",
    fill: "#FFA94A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M37.3908 27.6222C39.3371 25.2867 50.82 32.7214 44.592 33.0328C38.3639 33.3442 32.8366 32.5657 34.8607 30.6973C36.8848 28.8678 37.3908 27.6222 37.3908 27.6222Z",
    fill: "#D4D8A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M20.537 27.1931C23.3397 26.3757 30.1516 31.5917 27.6604 32.2534C25.1691 32.9151 17.3841 33.2265 15.7103 32.5648C14.0365 31.9031 17.5009 28.0495 20.537 27.1931Z",
    fill: "#D4D8A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M31.6295 44.6714C31.5517 45.8781 35.7167 39.9226 36.2227 38.8327C36.7676 37.7817 32.5248 32.7993 31.7463 32.6825C30.9678 32.5657 31.6295 44.6714 31.6295 44.6714Z",
    fill: "#D4D8A6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2129 20.6698C25.4053 17.4494 16.7076 16.7338 16.7076 16.7338C17.2856 25.1837 20.6436 31.2391 20.6436 31.2391C17.4233 37.0467 16.6801 45.7719 16.6801 45.7719C25.1301 45.1939 31.2129 41.8084 31.2129 41.8084C36.993 45.0012 45.7182 45.7444 45.7182 45.7444C45.1402 37.2944 41.7823 31.2391 41.7823 31.2391C44.9751 25.459 45.7457 16.7063 45.7457 16.7063C37.2958 17.2843 31.2129 20.6698 31.2129 20.6698Z",
    fill: "#FFD500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M29.1204 32.2307C27.3589 32.561 22.9275 32.1482 21.0283 31.2949C21.0283 31.2949 21.0283 31.2949 20.6429 31.2399C17.6978 36.5521 16.8171 44.2589 16.707 45.58C16.8171 45.525 16.9547 45.4424 17.0923 45.3598C24.4688 41.2862 30.882 31.9004 29.1204 32.2307Z",
    fill: "#FFA94A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M32.3395 29.5061C32.0368 31.075 42.7437 24.0563 45.7439 16.7073C37.2939 17.2853 31.211 20.6708 31.211 20.6708C32.7799 21.524 32.6698 27.9097 32.3395 29.5061Z",
    fill: "#FFA94A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.4766 43.0754C17.8894 45.2774 27.8531 43.3507 30.1652 41.9194C32.4772 40.4881 30.7432 30.7721 29.3395 33.0566C27.9357 35.3961 26.6421 37.8458 20.4766 43.0754Z",
    fill: "#8B002C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M20.23 43.2684C17.395 45.4428 21.5512 42.2225 24.2761 38.6718C27.001 35.1212 29.0103 31.9559 29.4782 32.3688C29.9461 32.7816 26.5881 38.3966 20.23 43.2684Z",
    fill: "#FFA94A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M19.7074 28.8184C21.1662 30.8827 29.1758 32.3415 27.0014 28.956C24.827 25.5705 16.4045 14.3957 17.0651 19.0198C17.7257 23.6438 18.8542 27.5798 19.7074 28.8184Z",
    fill: "#FFA94A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M27.0281 25.2958C23.1472 22.4057 16.8441 17.3688 19.6516 17.4789C22.459 17.589 29.3126 19.9286 30.7714 21.2772C32.2302 22.6259 33.0834 29.8098 27.0281 25.2958Z",
    fill: "#D4D8A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.1109 29.6171C32.3403 30.1125 38.7809 32.4246 41.2581 31.1034C43.7353 29.7822 45.7721 18.6074 43.2949 21.1396C40.8177 23.6718 37.8726 26.727 35.7808 27.9932C33.6614 29.2868 33.1109 29.6171 33.1109 29.6171Z",
    fill: "#8B002C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M33.5515 29.3406C31.5973 30.5792 36.4691 27.1386 40.818 22.0742C43.4328 19.074 46.543 15.5234 45.3595 17.5327C44.231 19.5419 42.1666 23.8082 33.5515 29.3406Z",
    fill: "#FFA94A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M30.6055 30.25C32.5047 30.9932 25.5136 24.7727 23.4217 22.5157C23.4217 22.5157 36.4407 23.2038 29.6422 19.8734C23.9722 17.3412 16.7058 16.7356 16.7058 16.7356C20.8069 20.8367 27.8256 29.1766 30.6055 30.25Z",
    fill: "#FFA94A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M22.4596 22.1032C21.8265 21.6903 26.5332 27.3878 28.7351 28.9842C30.9371 30.5806 31.9004 30.9384 28.7076 27.8007C25.5148 24.6629 24.3863 23.3693 22.4596 22.1032Z",
    fill: "#600A00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.6789 41.3411C29.3394 39.6621 38.6426 40.1025 41.6978 41.7264C41.6978 41.7264 39.6885 36.3042 39.9913 33.0838C40.294 29.8635 44.6704 35.6161 44.5053 44.8642C44.4777 44.8367 36.1654 44.5614 31.6789 41.3411Z",
    fill: "#8B002C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.24 41.7818C28.405 40.323 28.5977 36.0017 29.3683 33.0841C30.139 30.1666 31.6253 31.5428 35.0383 34.7906C38.4514 38.0385 45.7728 45.7453 45.7728 45.7453C45.7728 45.7453 38.5064 45.5251 31.24 41.7818Z",
    fill: "#8B002C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.6801 30.6351C31.8727 28.9836 44.699 29.369 41.2309 31.0755C37.7904 32.8095 34.6801 30.6351 34.6801 30.6351Z",
    fill: "#650056"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M34.3498 34.1027C31.4047 31.0475 35.1204 33.8274 37.1848 35.3413C39.2216 36.8276 42.1942 41.9471 41.0657 40.8186C39.9097 39.6626 34.3498 34.1027 34.3498 34.1027Z",
    fill: "#FFA94A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M32.3955 23.892C32.1203 20.8643 45.4971 18.0018 41.3134 22.6258C37.1297 27.2499 32.6708 30.6079 32.7809 27.8555C32.9185 25.1305 32.3955 23.892 32.3955 23.892Z",
    fill: "#D4D8A6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M20.1758 35.5064C21.5795 32.9466 30.0846 31.8181 28.7909 34.0476C27.4973 36.277 22.2126 42.0021 20.5611 42.7177C18.9097 43.4333 18.6344 38.2588 20.1758 35.5064Z",
    fill: "#D4D8A6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M40.3774 40.0211C41.1756 40.9294 39.9095 33.7731 39.4967 32.6446C39.1388 31.5161 32.6156 30.9931 31.9825 31.461C31.3495 31.929 40.3774 40.0211 40.3774 40.0211Z",
    fill: "#D4D8A6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M41.3734 22.1032C42.0065 21.6903 37.2998 27.3878 35.0979 28.9842C32.8959 30.5806 31.9326 30.9384 35.1254 27.8007C38.3182 24.6629 39.4467 23.3693 41.3734 22.1032Z",
    fill: "#600A00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M22.4596 40.9056C21.8265 41.3185 26.5332 35.621 28.7351 34.0246C30.9371 32.4282 31.9004 32.0703 28.7076 35.2081C25.5148 38.3459 24.3863 39.6395 22.4596 40.9056Z",
    fill: "#600A00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M41.3734 40.9056C42.0065 41.3185 37.2998 35.621 35.0979 34.0246C32.8959 32.4282 31.9326 32.0703 35.1254 35.2081C38.3182 38.3459 39.4467 39.6395 41.3734 40.9056Z",
    fill: "#600A00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4307_15868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9466,
    height: 44.8029,
    fill: "white",
    transform: "translate(9.4043 9.75488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldstar);
export default __webpack_public_path__ + "static/media/goldstar.b70182a939ffe454c1a28d51af7d8a3d.svg";
export { ForwardRef as ReactComponent };